import { RequirementFriendlyDescription } from "../requirementFriendlyDescription.js";
import { t2Part1DataSchema } from "../schemas/mhaForms/treatment/t2.js";
import { approvedClinicianAccreds } from "../types/user.js";
export const t2Part1Template = {
    signing: {
        userOrTeamRequirement: {
            accreditation: [...approvedClinicianAccreds],
            teamType: [],
            friendlyDescription: RequirementFriendlyDescription.approvedClinicianOrRegisteredMedicalPractitioner,
        },
    },
    formBuilderFields: [
        {
            type: "practitioner",
            label: "My email address, name, and address",
            field: "user",
        },
        {
            type: "branch",
            field: "userAccreditation",
            label: "I am",
            branches: [
                {
                    fieldValue: "approved-clinician",
                    label: "the approved clinician in charge of the treatment described below",
                    fieldsOwned: [],
                    fields: [],
                },
                {
                    fieldValue: "registered-medical-practitioner",
                    label: "a registered medical practitioner appointed for the purposes of Part 4 of the Act (a SOAD)",
                    fieldsOwned: [],
                    fields: [],
                },
            ],
        },
        {
            type: "readonly",
            label: "Name and address of patient",
            textFn: (data) => [
                data.patient?.name || "",
                [data.patient?.address, data.patient?.postalCode].join(", "),
            ],
            isReadOnlyPatientInfo: true,
        },
        {
            type: "textbox",
            field: "treatment",
            label: "Enter description of treatment or plan of treatment. Indicate clearly if the certificate is only to apply to any or all of the treatment for a specific period.",
            rows: "5",
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "(a) I certify that this patient is capable of understanding the nature, purpose and likely effects of the above stated treatment or plan of treatment.",
            ],
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "(b) I certify that this patient has consented to that treatment.",
            ],
        },
    ],
    dataSchema: t2Part1DataSchema,
};
export const t2V1Base = {
    id: "mha-t2",
    category: "treatment",
    version: "1.0",
    status: "active",
    formName: "T2",
    section: "58(3)(a)",
    parts: [t2Part1Template],
    description: "Certificate of Consent to Treatment",
    extractGenericData: () => ({}),
};
//# sourceMappingURL=t2.js.map